import React, { useCallback, useEffect, useState } from "react";
import { BiPlus, BiQuestionMark } from "react-icons/bi";
import { GrAscend, GrDescend } from "react-icons/gr";
import { PiMagnifyingGlass } from "react-icons/pi";
import { TbReload } from "react-icons/tb";
import { VscOrganization } from "react-icons/vsc";
import { useNavigate } from "react-router-dom";
import LoaderPublicAbilities from "../Loaders/LoaderPublicAbilities";
import { BsInfo, BsQuestion } from "react-icons/bs";
import Footer from "../Website/Footer";
import { GiMailbox } from "react-icons/gi";
import GetAbilityModal from "./GetAbilityModal";
import MandatorySign from "../Components/MandatorySign";
import ThreeDotsLoading from "../Loaders/ThreedotsLoading";
import InfoModalAbilities from "./InfoModalAbilities";
import { useLanguage } from "../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const MainAbilitiesDirectory = () => {
    const { t } = useLanguage()
    const navigate = useNavigate();
    const account_id = localStorage.getItem("account_id");

    const [loading, setLoading] = useState(true);
    const [loadingAbilities, setLoadingAbilities] = useState(false)
    const [userData, setUserData] = useState(null);
    const [publicAbilities, setPublicAbilities] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [selectedLink, setSelectedLink] = useState("")
    const [openGetAbilityModal, setOpenGetAbilityModal] = useState(false)
    const [selectedAbility, setSelectedAbility] = useState({})
    const [emptyIndex, setEmptyIndex] = useState(0);
    const [openInfoModal, setOpenInfoModal] = useState(false)

    const endpoint = `https://api.projecte8.com/ability/<org-id>/<abt-id>/<ability-endpoint>`

    const fetchUserData = useCallback(async (isInitialLoad = false) => {
        if (!account_id) return;

        try {
            if (isInitialLoad) setLoading(true);

            const response = await fetch(`${GEN_BACKEND_LINK}/get_session`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ account_id }),
            });

            if (!response.ok) throw new Error("Failed to fetch user session");

            const data = await response.json();
            setUserData(data);
        } catch (error) {
            console.error("Error fetching session:", error);
        } finally {
            if (isInitialLoad) setLoading(false);
        }
    }, [account_id]);

    const fetchPublicAbilities = useCallback(async () => {
        setLoadingAbilities(true)
        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_public_abilities`, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            });

            if (!response.ok) throw new Error("Failed to fetch public abilities");

            const data = await response.json();
            setPublicAbilities(data);
        } catch (error) {
            setLoadingAbilities(false)
            console.error("Error fetching public abilities:", error);
        } finally {
            setLoadingAbilities(false)
        }
    }, []);

    const filteredAbilities = publicAbilities.filter((ability) => {
        if (!searchTerm.trim()) return true;

        const term = searchTerm.toLowerCase();

        return (
            ability.id?.toString().toLowerCase().includes(term) ||
            ability.name?.toLowerCase().includes(term) ||
            ability.description?.toLowerCase().includes(term) ||
            ability.annotation?.toLowerCase().includes(term) ||
            ability.type?.toLowerCase().includes(term) ||
            ability.status?.toLowerCase().includes(term) ||
            ability.source_url?.toLowerCase().includes(term) ||
            ability.created_at?.toLowerCase().includes(term) ||
            String(ability.is_deprecated)?.toLowerCase().includes(term)
        );
    });

    const groupedAbilities = filteredAbilities.reduce((acc, ability) => {
        const type = ability.type || "Other";

        if (!acc[type]) acc[type] = [];
        acc[type].push(ability);

        return acc;
    }, {});

    const abilityTypes = Object.keys(groupedAbilities).sort((a, b) => {
        return a.localeCompare(b, undefined, { sensitivity: "base" });
    });

    const linkClick = (type) => {
        document.getElementById(`section-${type}`)?.scrollIntoView({ behavior: "smooth" });
        setSelectedLink(type)
    }

    const handleOpenGetAbilityModal = (ability) => {
        setSelectedAbility(ability)
        if (ability.id) {
            setOpenGetAbilityModal(true)
        }
    }

    const handleOpenInfoModal = (ability) => {
        setSelectedAbility(ability)
        if (ability.id) {
            setOpenInfoModal(true)
        }
    }

    const navigateUrlSales = () => {
        navigate("/contact/sales")
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setEmptyIndex((prev) => (prev + 1) % t.abilities.items_mcp.length);
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        fetchUserData(true);
        fetchPublicAbilities();
    }, [fetchUserData, fetchPublicAbilities]);

    useEffect(() => {
        if (abilityTypes[0]) {
            setSelectedLink(abilityTypes[0])
        }
    }, [publicAbilities]);

    return (
        <div className="directory_main_cont">
            <div className="directory_main_cont_navbar">
                <div className="directory_main_cont_navbar_inner">
                    <span>
                        {userData ? (
                            `${userData?.name} ${userData?.surname}`
                        ) : (
                            "Project E8"
                        )}
                    </span>
                    {userData ? (
                        <div className="directory_main_cont_navbar_inner_btn_cont">
                            <a
                                href="/e8console/organizations"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="confirmation_ability_get_btn fade-in"
                            >
                                <span>E8 Console</span>
                            </a>
                        </div>
                    ) : (
                        <div className="directory_main_cont_navbar_inner_btn_cont">
                            {/* <button className="login_btn" onClick={() => navigate("/login")}>
                                {t.website.navbar.login} <i className="fa-solid fa-login"></i>
                            </button>
                            <button className="start_now_btn" onClick={() => navigate("/register")}>
                                {t.website.navbar.start_now}
                            </button> */}
                            <button className="start_now_btn" onClick={navigateUrlSales}>
                                {t.website.sales.contact_btn}
                            </button>
                        </div>
                    )}

                </div>
            </div>

            <div className="directory_main_cont_body">
                <div className="directory_main_cont_body_inner">
                    <div className="mainframe_item_header" >
                        <p className="mainframe_item_title fade-in">{t.directory.welcome}</p>
                        <div className="mainframe_item_subtitle fade-in">
                            <p>{t.directory.explore}</p>
                        </div>
                    </div>

                    <div className="directories_items_cont_body">

                        <div className="directories_items_cont_top">
                            <div className="directories_items_cont_top_inner">
                                <p className="directories_items_cont_top_inner_title">{t.abilities.title}</p>
                                <p className="directories_items_cont_top_inner_description">
                                    {t.directory.punchline_desc}
                                </p>
                                {/* <button className="mainframe_item_create_btn fade-in mainframe_item_create_btn_anim"
                                >Publish an ability to the world</button> */}
                            </div>
                            <div className="directories_items_cont_top_inner_last">
                                <div className="back_img_directory"></div>
                                <div className="directories_items_cont_top_inner_last_inner">
                                    <div className="empty_chat_interface_item_mcp">
                                        <p
                                            key={emptyIndex}
                                            className="empty_chat_interface_item_desc fade-in"
                                        >
                                            {t.abilities.items_mcp[emptyIndex].desc}
                                        </p>
                                    </div>
                                    <div className="half_input_cont">
                                        <span>{t.playground.input_placeholder}</span>

                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="directories_items_cont_body_filtering">
                            <div className="filtering_mainframe_btn_cont fade-in">
                                <button
                                    className="filter_btn"
                                    onClick={() => fetchPublicAbilities()}
                                    title={t.reload}
                                >
                                    <TbReload />
                                </button>
                            </div>
                            <div className="filter_input_cont fade-in">
                                <input
                                    className="filter_input"
                                    placeholder={t.search_filter}
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                <span className="filter_input_icon"><PiMagnifyingGlass /></span>
                            </div>
                        </div>

                        <div className="main_abilities_container">
                            {loadingAbilities ? (
                                <div className="directories_items_cont">
                                    <LoaderPublicAbilities />
                                </div>
                            ) : (
                                filteredAbilities.length > 0 ? (
                                    abilityTypes.map((type) => (
                                        <div className={`${type == "soon available" && "ability_section_soon_available"}`}>
                                            <div key={type} id={`section-${type}`} className="ability_section">
                                                <p className={`ability_section_title ${type == "soon available" && "ability_section_title_white"}`}>{type.charAt(0).toUpperCase() + type.slice(1)}</p>
                                                <div className="directories_items_cont">
                                                    {groupedAbilities[type].map((ability) => (
                                                        <div className="directories_item">
                                                            <div
                                                                className="directories_item_second"
                                                                key={ability.id}
                                                            >
                                                                {type != "soon available" && (
                                                                    <div
                                                                        className="directories_item_img"
                                                                        style={{
                                                                            backgroundImage: `url(${ability.icon})`
                                                                        }}
                                                                    ></div>
                                                                )}
                                                                <div className="directories_item_inner">
                                                                    <div className="directories_item_header">
                                                                        <p className="directories_item_title">{ability.name}</p>
                                                                        <div className="directories_item_header_span">

                                                                            {ability.status == "verifying" ? (
                                                                                <span className="version_alert" onClick={(e) => e.stopPropagation()}>
                                                                                    <MandatorySign message={`We are currently validating the connection gateway with the ${ability.name} team. While the connection is active and secure, it is still undergoing verification by the provider. During the connection process in the consent screen, you may see a “not verified” or “unverified” status, you can ignore it and continue the connection.`} icon="info" />
                                                                                </span>
                                                                            ) : ability.status == "available" ? (
                                                                                <span className="model_item_public" onClick={(e) => e.stopPropagation()}>
                                                                                    <MandatorySign message={`${ability.name} ability and its connection have been verified by Project E8.`} icon="check" />
                                                                                </span>
                                                                            ) : (
                                                                                <span onClick={(e) => e.stopPropagation()}>
                                                                                    <MandatorySign message={`${ability.name} is currently under development and will be available soon.`} icon="asterisc" />
                                                                                </span>
                                                                            )}
                                                                        </div>

                                                                    </div>
                                                                    <div className="directories_item_body">
                                                                        <p className="directories_item_description">{ability.description}</p>
                                                                    </div>

                                                                    <div className="directories_item_footer">
                                                                        <button className="directories_item_footer_btn" onClick={() => handleOpenInfoModal(ability)}><BsInfo /></button>
                                                                        {userData?.account_id && (ability.status == "available" || ability.status == "verifying") && (
                                                                            <button
                                                                                className="directories_item_footer_btn"
                                                                                onClick={() => handleOpenGetAbilityModal(ability)}
                                                                            >{t.directory.get_ability}</button>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="organizations_cont_no_items_mex fade-in">
                                        <p>{t.no_abilities}</p>
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                </div>
                <div className="directory_main_cont_footer">

                    <div className="directory_main_cont_footer_inner">
                        <Footer />
                    </div>
                </div>
            </div>


            <GetAbilityModal
                account_id={account_id}
                show={openGetAbilityModal}
                handleClose={() => setOpenGetAbilityModal(false)}
                selectedAbility={selectedAbility}
            />

            <InfoModalAbilities
                show={openInfoModal}
                handleClose={() => setOpenInfoModal(false)}
                selectedAbility={selectedAbility}
            />
        </div>
    );
};

export default MainAbilitiesDirectory;